import { useAuth } from '../contexts/AuthContext';

export function useResiPermissions() {
    const { permissions } = useAuth();

    const {
        isResident,
        isGuest,
        isRental,
        isTenant,
        isLongTerm,
        isPrimary,
        isMinor,
        canInvite,
        canCalls,
        isSuspended,
        isLimited,
        isGated
    } = permissions || {};

    return {
        isResident,
        isGuest,
        isRental,
        isTenant,
        isLongTerm,
        isPrimary,
        isMinor,
        canInvite,
        canCalls,
        isSuspended,
        isLimited,
        isGated,
        isResidentRental: isResident && isRental,
        isTenantLongTerm: isTenant && isLongTerm,
        canManageUsers: isPrimary && canInvite,
        canManageCalls: isResident && canCalls,
        isTenantOrResident: isTenant || isResident
    };
}
